import { isDevMode, setDevMode } from './is-devmode';
import { getWhisper } from 'whisper-core-api';

/**
 * Logger utility that wraps console methods and respects a storage flag
 * All messages are prefixed with a configurable prefix (default: [Whisper Core])
 */
export class Logger {
  /**
   * Create a new Logger instance with a custom prefix
   * @param prefix The prefix to use for log messages (default: [Whisper Core])
   */
  constructor(prefix = '') {
    this.prefix = prefix;
  }

  /**
   * Checks if logging is enabled in storage
   */
  static isEnabled() {
    return isDevMode();
  }

  /**
   * Enable logging
   */
  static debug(enabled) {
    setDevMode(enabled);
  }

  /**
   * Log a standard message if logging is enabled
   */
  log(...args) {
    if (Logger.isEnabled()) {
      console.log(this.prefix, ...args);
    }
  }

  /**
   * Log a warning message if logging is enabled
   */
  warn(...args) {
    if (Logger.isEnabled()) {
      console.warn(this.prefix, ...args);
    }
  }

  /**
   * Log an error message if logging is enabled
   */
  error(message, error) {
    var _getWhisper;
    if (Logger.isEnabled()) {
      console.error(this.prefix, message, error || '');
    }
    const captureError = (_getWhisper = getWhisper()) === null || _getWhisper === void 0 ? void 0 : _getWhisper.captureError;
    if (captureError) {
      captureError(message, error);
    }
  }

  /**
   * Log info message if logging is enabled
   */
  info(...args) {
    if (Logger.isEnabled()) {
      console.info(this.prefix, ...args);
    }
  }

  /**
   * Log debug message if logging is enabled
   */
  debug(...args) {
    if (Logger.isEnabled()) {
      console.debug(this.prefix, ...args);
    }
  }
}